module.exports = "<!-- $Id$ -->\r\n<ng-template style=\"width: 500; height: 500;\">\r\n    <div class=\"modal-header\">\r\n      <button type=\"button\" class=\"btn btn-default close\" (click)=\"cancel()\">\r\n        &times;\r\n      </button>\r\n      Relatório disponível para download\r\n    </div>\r\n    <div class=\"modal-body\" style=\"text-align: center;\">\r\n      <p>\r\n        <button type=\"button\" class=\"btn btn-default\" (click)=\"download()\">Baixar Relatório {{ fileName }}</button>\r\n      </p>\r\n    </div>\r\n    <hr class=\"hrcinza\">\r\n  </ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/modals/report/content.template.html
// module id = 1188
// module chunks = 1